// Mock JWT tokens for demonstration
export const MOCK_TOKENS = {
    user1: {
        token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEiLCJuYW1lIjoiSm9obiBEb2UiLCJlbWFpbCI6ImpvaG5AZXhhbXBsZS5jb20iLCJzbHVnIjoiam9obi1kb2UiLCJpYXQiOjE2MDA2MzAyMzIsImV4cCI6MjAwMDYzMDIzMn0.5_hn7l6Z8YqH9kZ7qJ5hF2mN0pY1cV3bW2xR4sT6uU8',
        refreshToken: 'refresh_token_user1',
        user: {
            id: '1',
            name: 'John Doe',
            email: 'john@example.com',
            slug: 'john-doe',
        },
    },
};

// Mock family tree data - New API format
export const MOCK_FAMILY_TREE_NEW_FORMAT = {
    familyTree: {
        id: 'family-tree-uuid-1',
        slug: 'doe-family',
        name: 'Doe Family Tree',
        description: 'The Doe family history',
        rootMemberId: 'grandpa',
        visibility: 'private'
    },
    nodes: [
        // Generation 0 - Grandparents
        {
            id: 'grandpa',
            name: 'Robert Doe Sr.',
            gender: 'male',
            birthDate: '1940-01-15',
            deathDate: '2010-05-20',
            occupation: 'Engineer',
            profileImage: null,
            documents: [],
            parents: [],
            siblings: [],
            spouses: [{ id: 'grandma', type: 'married' }],
            children: [{ id: 'dad', type: 'blood' }, { id: 'uncle', type: 'blood' }]
        },
        {
            id: 'grandma',
            name: 'Mary Doe',
            gender: 'female',
            birthDate: '1942-03-10',
            deathDate: '2015-08-12',
            profileImage: null,
            documents: [],
            parents: [],
            siblings: [],
            spouses: [{ id: 'grandpa', type: 'married' }],
            children: [{ id: 'dad', type: 'blood' }, { id: 'uncle', type: 'blood' }]
        },

        // Generation 1 - Parents
        {
            id: 'dad',
            name: 'John Doe',
            gender: 'male',
            birthDate: '1970-06-22',
            deathDate: null,
            profileImage: null,
            documents: [],
            parents: [{ id: 'grandpa', type: 'blood' }, { id: 'grandma', type: 'blood' }],
            siblings: [{ id: 'uncle', type: 'blood' }],
            spouses: [{ id: 'mom', type: 'married' }],
            children: [{ id: 'son1', type: 'blood' }, { id: 'daughter1', type: 'blood' }]
        },
        {
            id: 'mom',
            name: 'Jane Smith',
            gender: 'female',
            birthDate: '1972-09-15',
            deathDate: null,
            profileImage: null,
            documents: [],
            parents: [],
            siblings: [],
            spouses: [{ id: 'dad', type: 'married' }],
            children: [{ id: 'son1', type: 'blood' }, { id: 'daughter1', type: 'blood' }]
        },
        {
            id: 'uncle',
            name: 'Michael Doe',
            gender: 'male',
            birthDate: '1975-11-05',
            deathDate: null,
            profileImage: null,
            documents: [],
            parents: [{ id: 'grandpa', type: 'blood' }, { id: 'grandma', type: 'blood' }],
            siblings: [{ id: 'dad', type: 'blood' }],
            spouses: [{ id: 'aunt', type: 'married' }],
            children: [{ id: 'cousin1', type: 'blood' }]
        },
        {
            id: 'aunt',
            name: 'Sarah Johnson',
            gender: 'female',
            birthDate: '1977-04-18',
            deathDate: null,
            profileImage: null,
            documents: [],
            parents: [],
            siblings: [],
            spouses: [{ id: 'uncle', type: 'married' }],
            children: [{ id: 'cousin1', type: 'blood' }]
        },

        // Generation 2 - Children
        {
            id: 'son1',
            name: 'David Doe',
            gender: 'male',
            birthDate: '2000-03-12',
            deathDate: null,
            profileImage: null,
            documents: [],
            parents: [{ id: 'dad', type: 'blood' }, { id: 'mom', type: 'blood' }],
            siblings: [{ id: 'daughter1', type: 'blood' }],
            spouses: [],
            children: []
        },
        {
            id: 'daughter1',
            name: 'Emily Doe',
            gender: 'female',
            birthDate: '2003-07-25',
            deathDate: null,
            profileImage: null,
            documents: [],
            parents: [{ id: 'dad', type: 'blood' }, { id: 'mom', type: 'blood' }],
            siblings: [{ id: 'son1', type: 'blood' }],
            spouses: [],
            children: []
        },
        {
            id: 'cousin1',
            name: 'Alex Doe',
            gender: 'male',
            birthDate: '2005-12-08',
            deathDate: null,
            profileImage: null,
            documents: [],
            parents: [{ id: 'uncle', type: 'blood' }, { id: 'aunt', type: 'blood' }],
            siblings: [],
            spouses: [],
            children: []
        }
    ]
};

// Keep old format for backward compatibility
export const MOCK_FAMILY_TREE = {
    slug: 'doe-family',
    familyName: 'Doe Family',
    rootNodeId: 'gen0-p1',
    members: [
        // Generation 0 - Grandparents
        {
            id: 'gen0-p1',
            name: 'Richard Doe',
            firstName: 'Richard',
            lastName: 'Doe',
            birthDate: '1920-03-15',
            deathDate: '1995-12-20',
            gender: 'male',
            images: [],
            parents: [],
            siblings: [],
            spouses: [{ id: 'gen0-p2', type: 'married' }],
            children: [
                { id: 'gen1-p1', type: 'blood' },
                { id: 'gen1-p2', type: 'blood' }
            ],
        },
        {
            id: 'gen0-p2',
            name: 'Patricia Doe',
            firstName: 'Patricia',
            lastName: 'Doe',
            birthDate: '1922-05-30',
            deathDate: '1998-08-10',
            gender: 'female',
            images: [],
            parents: [],
            siblings: [],
            spouses: [{ id: 'gen0-p1', type: 'married' }],
            children: [
                { id: 'gen1-p1', type: 'blood' },
                { id: 'gen1-p2', type: 'blood' }
            ],
        },
        {
            id: 'gen0-p3',
            name: "John's Dad",
            firstName: "John's",
            lastName: 'Dad',
            birthDate: '1918-09-05',
            deathDate: '1992-03-15',
            gender: 'male',
            images: [],
            parents: [],
            siblings: [],
            spouses: [{ id: 'gen0-p4', type: 'married' }],
            children: [{ id: 'gen1-p3', type: 'blood' }],
        },
        {
            id: 'gen0-p4',
            name: "John's Mom",
            firstName: "John's",
            lastName: 'Mom',
            birthDate: '1920-11-22',
            deathDate: '2000-07-18',
            gender: 'female',
            images: [],
            parents: [],
            siblings: [],
            spouses: [{ id: 'gen0-p3', type: 'married' }],
            children: [{ id: 'gen1-p3', type: 'blood' }],
        },
        {
            id: 'gen0-p5',
            name: 'Emily Johnson',
            firstName: 'Emily',
            lastName: 'Johnson',
            birthDate: '1945-11-12',
            deathDate: '1980-09-05',
            gender: 'female',
            images: [],
            parents: [],
            siblings: [],
            spouses: [],
            children: [{ id: 'gen1-p4', type: 'blood' }],
        },
        // Generation 1 - Parents
        {
            id: 'gen1-p1',
            name: 'Robert Doe',
            firstName: 'Robert',
            lastName: 'Doe',
            birthDate: '1945-03-15',
            deathDate: '2010-12-20',
            gender: 'male',
            images: [
                {
                    id: 'img-1-1',
                    title: 'Robert',
                    url: 'https://via.placeholder.com/300?text=Robert',
                    type: 'url',
                },
            ],
            parents: [
                { id: 'gen0-p1', type: 'blood' },
                { id: 'gen0-p2', type: 'blood' }
            ],
            siblings: [{ id: 'gen1-p2', type: 'blood' }],
            spouses: [{ id: 'gen1-p4', type: 'married' }],
            children: [{ id: 'gen2-p1', type: 'blood' }],
        },
        {
            id: 'gen1-p2',
            name: 'Margaret Doe',
            firstName: 'Margaret',
            lastName: 'Doe',
            birthDate: '1947-05-30',
            deathDate: '2015-08-10',
            gender: 'female',
            images: [],
            parents: [
                { id: 'gen0-p1', type: 'blood' },
                { id: 'gen0-p2', type: 'blood' }
            ],
            siblings: [{ id: 'gen1-p1', type: 'blood' }],
            spouses: [],
            children: [],
        },
        {
            id: 'gen1-p3',
            name: 'William Smith',
            firstName: 'William',
            lastName: 'Smith',
            birthDate: '1943-09-05',
            deathDate: null,
            gender: 'male',
            images: [],
            parents: [
                { id: 'gen0-p3', type: 'blood' },
                { id: 'gen0-p4', type: 'blood' }
            ],
            siblings: [],
            spouses: [],
            children: [{ id: 'gen2-p2', type: 'blood' }],
        },
        {
            id: 'gen1-p4',
            name: 'Emily Johnson',
            firstName: 'Emily',
            lastName: 'Johnson',
            birthDate: '1965-11-12',
            deathDate: null,
            gender: 'female',
            images: [],
            parents: [{ id: 'gen0-p5', type: 'blood' }],
            siblings: [],
            spouses: [{ id: 'gen1-p1', type: 'married' }],
            children: [{ id: 'gen2-p1', type: 'blood' }],
        },
        // Generation 2 - Children
        {
            id: 'gen2-p1',
            name: 'Jane Doe',
            firstName: 'Jane',
            lastName: 'Doe',
            birthDate: '1990-01-10',
            deathDate: null,
            gender: 'female',
            images: [
                {
                    id: 'img-2-1',
                    title: 'Jane',
                    url: 'https://via.placeholder.com/300?text=Jane',
                    type: 'url',
                },
            ],
            parents: [
                { id: 'gen1-p1', type: 'blood' },
                { id: 'gen1-p4', type: 'blood' }
            ],
            siblings: [],
            spouses: [{ id: 'gen2-p2', type: 'married' }],
            children: [
                { id: 'gen3-p1', type: 'blood' },
                { id: 'gen3-p2', type: 'blood' }
            ],
        },
        {
            id: 'gen2-p2',
            name: 'Michael Doe',
            firstName: 'Michael',
            lastName: 'Doe',
            birthDate: '1988-04-22',
            deathDate: null,
            gender: 'male',
            images: [],
            parents: [{ id: 'gen1-p3', type: 'blood' }],
            siblings: [],
            spouses: [{ id: 'gen2-p1', type: 'married' }],
            children: [
                { id: 'gen3-p1', type: 'blood' },
                { id: 'gen3-p2', type: 'blood' }
            ],
        },
        // Generation 3 - Grandchildren
        {
            id: 'gen3-p1',
            name: 'John Doe',
            firstName: 'John',
            lastName: 'Doe',
            birthDate: '2010-06-12',
            deathDate: null,
            gender: 'male',
            images: [
                {
                    id: 'img-3-1',
                    title: 'John',
                    url: 'https://via.placeholder.com/300?text=John',
                    type: 'url',
                },
            ],
            parents: [
                { id: 'gen2-p1', type: 'blood' },
                { id: 'gen2-p2', type: 'blood' }
            ],
            siblings: [{ id: 'gen3-p2', type: 'blood' }],
            spouses: [],
            children: [],
        },
        {
            id: 'gen3-p2',
            name: 'Sarah Doe',
            firstName: 'Sarah',
            lastName: 'Doe',
            birthDate: '2013-09-20',
            deathDate: null,
            gender: 'female',
            images: [],
            parents: [
                { id: 'gen2-p1', type: 'blood' },
                { id: 'gen2-p2', type: 'blood' }
            ],
            siblings: [{ id: 'gen3-p1', type: 'blood' }],
            spouses: [],
            children: [],
        },
    ],
};

// Mock API response handlers
export const mockApiResponses = {
    // Authentication
    login: (email, password) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    data: MOCK_TOKENS.user1,
                });
            }, 500);
        });
    },

    // Members
    createMember: (data) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    data: {
                        success: true,
                        familyTree: MOCK_FAMILY_TREE,
                        message: 'Family tree loaded successfully',
                    },
                });
            }, 500);
        });
    },

    verifySlug: (slug) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                if (slug === 'doe-family' || slug === 'john-doe') {
                    resolve({
                        data: {
                            valid: true,
                            familyTree: MOCK_FAMILY_TREE,
                            message: 'Slug verified successfully',
                        },
                    });
                } else {
                    resolve({
                        data: {
                            valid: false,
                            message: 'Invalid slug',
                        },
                    });
                }
            }, 500);
        });
    },

    getFamilyTree: (slug) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    data: MOCK_FAMILY_TREE_NEW_FORMAT,
                });
            }, 500);
        });
    },

    updateMember: (id, data) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    data: {
                        success: true,
                        member: { id, ...data },
                    },
                });
            }, 500);
        });
    },

    uploadImage: (file, memberId) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    data: {
                        success: true,
                        image: {
                            id: `img-${Date.now()}`,
                            memberId,
                            url: 'https://via.placeholder.com/300',
                            type: 'upload',
                        },
                    },
                });
            }, 500);
        });
    },
};
